import * as React from "react";
const SvgFiRrFireBurner = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fire-burner_svg__a)">
      <path
        fill="#062147"
        d="M12 13.998c3.231 0 6-2.912 6-6.027 0-2.819-2.505-5.108-4.334-6.779-.357-.326-.687-.626-.959-.898a.92.92 0 0 0-.743-.292c-.277.01-.538.135-.72.345-.928 1.07-1.263 2.481-1.532 3.615l-.055.23a.999.999 0 0 0-1.708-.555C7.363 4.241 6 5.874 6 7.971c0 3.115 2.769 6.027 6 6.027m.707-2.291c-.124.124-.271.234-.707.264s-.583-.139-.707-.264a1 1 0 0 1 0-1.414L12 9.586l.707.707a1 1 0 0 1 0 1.414M8.392 6.43c.329.349.774.57 1.344.57 1.311 0 1.636-1.369 1.923-2.577.145-.61.302-1.272.55-1.854 1.554 1.42 3.792 3.464 3.792 5.401a4 4 0 0 1-1.024 2.67 3 3 0 0 0-.855-1.762l-1.414-1.414a1 1 0 0 0-1.414 0L9.88 8.878a3 3 0 0 0-.855 1.762 3.99 3.99 0 0 1-1.024-2.67c0-.56.169-1.088.392-1.541zM22 18.172V17c0-2.206-1.794-4-4-4a1 1 0 1 0 0 2c1.103 0 2 .897 2 2v1H4v-1c0-1.103.897-2 2-2a1 1 0 1 0 0-2c-2.206 0-4 1.794-4 4v1.172A3 3 0 0 0 0 21c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3a3 3 0 0 0-2-2.828M7 22H3a1 1 0 0 1 0-2h4zm4 0H9v-2h2zm4 0h-2v-2h2zm6 0h-4v-2h4a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fire-burner_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireBurner;
